import sliceCreator from '../../index.jsx';
import {GET_ALL_TENANTS} from '../../../constants/index.jsx';
const _getAllTenantsAction = sliceCreator('GET_ALL_TENANTS', GET_ALL_TENANTS, 'get');

const { asyncAction: getAllTenantsAction, reducer, clearData: clearGetAllTenantsAction } = _getAllTenantsAction;

export default reducer;

export {
    getAllTenantsAction,
    clearGetAllTenantsAction
}